import request from '@/request'
// 获取微信分享地址
export const getShare = data => {
  return request({
    url: '/servlet/ShareServlet',
    method: 'post',
    data,
    isMd5: false
  })
}
// 获取微信jssdk授权接口
export const getConfig = data => {
  return request({
    url: '/inf_WxcpJssdk_Vipwd/getJsapiSignature.action',
    method: 'post',
    data,
    isMd5: true
  })
}
// 上传
export const addFile = data => {
  return request({
    url: '/inf_FtuWxcpMedia_Vipwd/addPicture.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
